import {
  mergeTickerWithWs,
  sortListByDisplayWeightDesc,
  getCfdQuoteCurrencyUpper,
  resolveAllowedFiatQuotesForRecommend,
} from "./cfdTabListSource";

/** 与 MarketList optional / Fiat-M 二级 Tab 一致 */
export function rowMatchesRecommendSubTab(m, subTab) {
  if (!subTab) return true;
  const plates = Array.isArray(m?.plates) ? m.plates : [];
  const has260 = plates.includes(260);
  const has261 = plates.includes(261);
  if (subTab === "commodities") return has260;
  if (subTab === "stocks") return has261;
  if (subTab === "crypto") return !has260 && !has261;
  return true;
}

/**
 * Favourite 空态推荐列表
 * 1. symbol 以 _cfd 结尾
 * 2. 计价在 USDT ∪ 命中法币 内
 * 3. 按 marketConfig.displayWeight 降序
 */
export function getRecommendPairs({
  marketConfig,
  resData,
  wsData,
  activeFiatCodes,
  activeFiatCode,
  subTab = "",
  limit = 6,
}) {
  if (!marketConfig || !Object.keys(marketConfig).length || !Array.isArray(resData)) return [];

  const fiatHitQuotes = resolveAllowedFiatQuotesForRecommend(activeFiatCodes, activeFiatCode);
  const allowedQuoteSet = new Set(["USDT", ...fiatHitQuotes.map((c) => String(c).toUpperCase())]);

  const rows = resData
    .filter((item) => {
      if (!item || !item.s) return false;
      const sym = String(item.s);
      if (!sym.toLowerCase().endsWith("_cfd")) return false;
      const m = marketConfig[sym];
      if (!m || m.state === "DELISTED") return false;
      if (String(m.type || "").toUpperCase() !== "CFD") return false;
      const quote = getCfdQuoteCurrencyUpper(sym);
      if (!quote || !allowedQuoteSet.has(quote)) return false;
      if (subTab && !rowMatchesRecommendSubTab(m, subTab)) return false;
      return true;
    })
    .map((item) => mergeTickerWithWs(item, wsData));

  sortListByDisplayWeightDesc(rows, marketConfig);
  return rows.slice(0, limit);
}
